<template>
    <div class="dialog-container" :class="{ 'mobile-dialog-container': isMobile }" v-if="isShow">
        <div class="container">
            <div class="title">请输入订单手机号验证</div>
            <div class="form">
                <div class="item">
                    <input @input="onChange" v-model.trim="telNo" placeholder="请输入" />
                    <div class="label">{{ telNo.length }}/11</div>
                </div>
            </div>
            <div class="submit-btn" @click="onSubmit">确 认</div>
            <div class="desc">请填写下单的手机号，手机号只用于订单验证，不会用于身份验证。</div>
        </div>
    </div>
</template>
<script>
import { getActiveQualification } from '@/utils/api.js'

export default {
    props: ['isMobile'],
    data() {
        return {
            isShow: true,
            telNo: '',
        }
    },
    methods: {
        onChange() {
            this.telNo = this.telNo.substr(0, 11)
        },
        onSubmit() {
            const rule = new RegExp(/^1[0-9]{10}$/)
            if (!rule.test(this.telNo)) {
                return this.$toast('请输入正确订单手机号')
            }
            getActiveQualification({ telNo: this.telNo }).then(res => {
                this.isShow = !res.data
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.dialog-container {
    .container {
        background: #fff;
        font-size: 14px;
        width: 300px;
        height: 240px;
        border-radius: 4px;
        .title {
            font-size: 18px;
            color: #33312f;
            line-height: 18px;
            padding: 24px 0;
            text-align: center;
        }
        .item {
            width: 240px;
            height: 32px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #e6e6e6;
            box-sizing: border-box;
            margin: 0 auto;
            position: relative;
            margin: 12px auto;
            .label {
                position: absolute;
                top: 0;
                right: 4px;
                height: 30px;
                line-height: 30px;
                color: #666;
            }
        }
        input {
            width: 100%;
            height: 100%;
            font-size: 14px;
            color: #33312f;
            line-height: 24px;
            padding: 6px 30px 6px 12px;
            box-sizing: border-box;
            background: none;
            border: none;
        }
        .submit-btn {
            color: #ffffff;
            background: #44cd94;
            width: 100px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            font-weight: 700;
            font-size: 14px;
            color: #ffffff;
            margin: 32px auto 12px;
            cursor: pointer;
            &:active {
                opacity: 0.94;
            }
        }
        .desc {
            font-size: 12px;
            color: #888;
            line-height: 1.4em;
            padding: 0 40px;
            text-align: center;
        }
    }
}

.mobile-dialog-container {
    .container {
        width: 300px;
        height: 240px;
        .title {
            font-size: 18px;
            line-height: 1em;
            height: 1em;
            padding: 16px;
        }
        .item {
            width: 240px;
            height: 32px;
            margin-bottom: 16px;
        }
        input {
            height: 32px;
            font-size: 14px;
            line-height: 32px;
        }
        .code-btn {
            width: 96px;
        }

        .submit-btn {
            width: 90px;
            height: 28px;
            font-size: 13px;
            font-weight: 500;
            border-radius: 2px;
            margin: 32px auto 8px;
        }
    }
}
</style>
